/* Movelyn fixes 27 Oct: sticky/try CTA -> offer, no double add, Basket -> Cart */
(function () {
  if (window.__vlFixes) return; window.__vlFixes = true;
  var d = document, NB = 'Add to\u00a0cart';
  var css = d.createElement('style');
  css.textContent = '#cart-icon-bubble .vl-bsk{font-size:0!important}#cart-icon-bubble .vl-bsk::after{content:"Cart";font-size:14px}';
  d.head.appendChild(css);

  function goOffer() {
    var o = d.querySelector('[data-deal-block-id]');
    var bars = d.querySelectorAll('[data-deal-block-id] .kaching-bundles__bar-container');
    var t = bars[1];
    if (t) { var bar = t.closest('.kaching-bundles__bar'); if (!bar || !bar.classList.contains('kaching-bundles__bar--selected')) t.click(); }
    if (o) {
      o.scrollIntoView({ behavior: 'smooth', block: 'center' });
      o.style.transition = 'box-shadow .3s'; o.style.borderRadius = '12px';
      o.style.boxShadow = '0 0 0 4px rgba(21,96,79,.35)';
      setTimeout(function () { o.style.boxShadow = ''; }, 1600);
    } else { location.href = '/products/gel-cushion'; }
  }
  window.vlGoOffer = goOffer;

  var has = false, CUSH_HANDLE = 'gel-cushion';
  function chk() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { has = c.items.some(function (i) { return i.handle === CUSH_HANDLE; }); }).catch(function () {});
  }
  var re = /\/cart\/(add|change|update|clear)/;
  var of = window.fetch;
  window.fetch = function () {
    var a = arguments[0], u = typeof a === 'string' ? a : (a && a.url) || '';
    var pr = of.apply(this, arguments);
    if (re.test(u)) pr.then(function () { setTimeout(chk, 700); }, function () {});
    return pr;
  };
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (re.test(u || '')) this.addEventListener('load', function () { setTimeout(chk, 700); });
    return oo.apply(this, arguments);
  };
  chk(); window.addEventListener('pageshow', chk);

  d.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target : null; if (!el) return;
    var cta = el.closest('[data-vl-sb],[data-vl-try]');
    if (cta) { e.preventDefault(); e.stopImmediatePropagation(); goOffer(); return; }
    var sub = el.closest('.product-form__submit');
    if (sub && has) {
      e.preventDefault(); e.stopImmediatePropagation();
      var ic = d.getElementById('cart-icon-bubble');
      if (ic) ic.click(); else location.href = '/cart';
    }
  }, true);

  function words() {
    var sb = d.querySelector('[data-vl-sb]');
    if (sb && sb.textContent !== 'Claim 1 + 1 FREE') sb.textContent = 'Claim 1 + 1 FREE';
    var st = d.querySelector('.vl-stk'); if (st) st.setAttribute('aria-label', 'Special offer');
    var tr = d.querySelector('[data-vl-try]');
    if (tr && /basket/i.test(tr.textContent)) tr.textContent = tr.textContent.replace(/Add to basket/i, 'Claim 1 + 1 FREE');
    d.querySelectorAll('.product-form__submit span:first-child, [data-vl-hadd]').forEach(function (l) {
      if (l.children.length) return;
      var t = l.textContent.trim();
      if (t === 'Add to basket' || t === 'Add to cart') l.textContent = NB;
    });
  }
  var q = false;
  function sched() { if (q) return; q = true; requestAnimationFrame(function () { q = false; words(); }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', words); else words();
  new MutationObserver(sched).observe(d.documentElement, { childList: true, subtree: true, characterData: true });
})();
